import { defineComponent, openBlock, createElementBlock, normalizeStyle } from 'vue';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "toolbar-divider",
  props: {
    width: {},
    height: {},
    marginLeft: {},
    marginRight: {},
    backgroundColor: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "se-toolbar-divider",
        style: normalizeStyle({
          width: __props.width,
          height: __props.height,
          marginLeft: __props.marginLeft,
          marginRight: __props.marginRight,
          backgroundColor: __props.backgroundColor
        })
      }, null, 4);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=toolbar-divider.vue.js.map
